import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'bxl-super-user',
  templateUrl: 'super-user.component.html',
})
export class SuperUserComponent implements OnInit {
  initialized = true;
  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle('SuperUser - BehaviorLive');
  }
}
